export default {
  mutations: {
    SET_STATE: 'SET_STATE',
  },
  getters: {
    GET_STATE: 'GET_STATE',
  },
  actions: {
    STATE_LIST: 'STATE_LIST',
  },
};
